module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/publicar-aviso.d38d16c0.svg";